import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { JaneStreetPfofJobsTable } from '../../../../../../../../../../../features/vendor/jane-street/pfof/job/jane-street-pfof-jobs-table';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/')({
  // staticData: {
  //   tab: {
  //     group: TabbedNavigationGroup.ClearingVendorJaneStreet,
  //     label: 'PFOF Jobs',
  //     order: 0,
  //   },
  // } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorJaneStreet>,
  head: () => getPageHead('Jane Street PFOF Jobs'),
  component: JaneStreetPfofJobsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  // return <PageTabRail actions={filter} group={TabbedNavigationGroup.ClearingVendorJaneStreet} />;
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      {filter}
    </HorizontalStack>
  );
}

function JaneStreetPfofJobsList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <JaneStreetPfofJobsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
